var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16699 4H8.83366V9.5H7.16699V4Z",
    fill: "#C84848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44443 10.8352C7.60888 10.7253 7.80222 10.6666 8 10.6666C8.26522 10.6666 8.51957 10.772 8.70711 10.9595C8.89464 11.1471 9 11.4014 9 11.6666C9 11.8644 8.94135 12.0577 8.83147 12.2222C8.72159 12.3866 8.56541 12.5148 8.38268 12.5905C8.19996 12.6662 7.99889 12.686 7.80491 12.6474C7.61093 12.6088 7.43275 12.5136 7.29289 12.3737C7.15304 12.2339 7.0578 12.0557 7.01922 11.8617C6.98063 11.6677 7.00043 11.4667 7.07612 11.2839C7.15181 11.1012 7.27998 10.945 7.44443 10.8352Z",
    fill: "#C84848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 14C11.314 14 14.0003 11.3137 14.0003 7.99996C14.0003 4.68625 11.314 1.99996 8.00033 1.99996C4.68662 1.99996 2.00033 4.68625 2.00033 7.99996C2.00033 11.3137 4.68662 14 8.00033 14ZM8.00033 15.3333C12.0504 15.3333 15.3337 12.05 15.3337 7.99996C15.3337 3.94987 12.0504 0.666626 8.00033 0.666626C3.95024 0.666626 0.666992 3.94987 0.666992 7.99996C0.666992 12.05 3.95024 15.3333 8.00033 15.3333Z",
    fill: "#C84848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_1893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.51a6b538912297991613137251739be4.svg";
export { ForwardRef as ReactComponent };